import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

type Tone = 'note' | 'confirm' | 'caution';

interface CalloutProps {
  tone?: Tone;
  title?: string;
  children: ReactNode;
}

/** A rule down the left edge, echoing the green top rules on the Smart Home
 *  site's three-up feature row. */
const tones: Record<Tone, string> = {
  note: 'border-l-grey-300 bg-grey-050',
  confirm: 'border-l-green-600 bg-green-050',
  caution: 'border-l-alert bg-white',
};

const titleTone: Record<Tone, string> = {
  note: 'text-ink',
  confirm: 'text-green-900',
  caution: 'text-alert',
};

export default function Callout({ tone = 'note', title, children }: CalloutProps) {
  return (
    <div
      className={cx('rounded-r-sm border-l-[3px] py-4 pr-5 pl-5', tones[tone])}
      role={tone === 'caution' ? 'alert' : undefined}
    >
      {title && <p className={cx('t-h3 mb-1', titleTone[tone])}>{title}</p>}
      <div className="t-body measure text-grey-600">{children}</div>
    </div>
  );
}
